import { AddressType } from 'wflow-main-app/src/app/core/api/model/partner';
import { getCountryName } from './country-name.util';
import { formatPostalCode } from './postal-code.util';

export function hasAllRequiredAddressFields(
  address: AddressType | null | undefined,
): boolean {
  return (
    !!address?.streetAndNumber?.trim() &&
    !!address?.postalCode?.trim() &&
    !!address?.city?.trim() &&
    !!address?.countryCode?.trim()
  );
}

/**
 * Composes a one-line address. With a `locale` the output is localized for
 * display; without one it is raw (unspaced postal code, untranslated country code)
 */
export function formatAddress(
  address: AddressType | null | undefined,
  fallback?: string,
  locale?: string,
): string {
  if (!address) {
    return fallback ?? '';
  }

  const street = [address.streetAndNumber, address.addressSupplement]
    .filter(Boolean)
    .join(', ');

  const postalCity = [formatPostalCode(address.postalCode, locale), address.city]
    .filter(Boolean)
    .join(' ');

  const country = locale
    ? getCountryName(address.countryCode, locale)
    : (address.countryCode ?? '').trim().toUpperCase();

  return [street, postalCity, country].filter(Boolean).join(', ');
}
